export default __webpack_public_path__ + "56be5f601dd55931688783652b0ff712.ttf";